import { download } from '../api/schedule'
import downloadAsFile from 'downloadjs'
import { addInfoNotification, addErrorNotification } from './notifications'

const GET_SCHEDULES_STARTED = 'schedules/GET_SCHEDULES_STARTED'
const GET_SCHEDULES_SUCCEEDED = 'schedules/GET_SCHEDULES_SUCCEEDED'
const GET_SCHEDULES_FAILED = 'schedules/GET_SCHEDULES_FAILED'

const downloadSchedulesAsync = (tenant) => dispatch => {
  dispatch({
    type: GET_SCHEDULES_STARTED
  })

  const fileName = `schedule_${tenant}.json`
  return download()
    .then(async response => {
      const blob = response.blob()
      if (response.ok) {
        return blob
      }
      else {
        return blob.then(() => { throw Error(response.statusText) })
      }
    })
    .then(data => {
      downloadAsFile(data, fileName, 'application/json')
      dispatch({
        type: GET_SCHEDULES_SUCCEEDED,
        data
      })
      dispatch(addInfoNotification('Schedule downloaded.', fileName))
    })
    .catch(error => {
      dispatch({
        type: GET_SCHEDULES_FAILED,
        error: error.message
      })
      dispatch(addErrorNotification('Schedule download Failed.', error.message))
    })
}

export {
  GET_SCHEDULES_STARTED,
  GET_SCHEDULES_SUCCEEDED,
  GET_SCHEDULES_FAILED,
  downloadSchedulesAsync
}



// WEBPACK FOOTER //
// ./src/actions/schedules.js